export default {
    
    ORDER_SENT: 'Order Placed',
    ORDER_RECEIVED: 'Order Received',
    ORDER_ACCEPTED: 'Order Accepted',
    ORDER_REJECTED: 'Order Rejected',
    ORDER_OUT_FOR_DELIVERY: 'Out for Delivery',
    ORDER_DELIVERED: 'Delivered'
}